module.exports = __webpack_public_path__ + "04_medium_black.92769b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_medium_black.png
// module id = OLII
// module chunks = 0